import http from '../../utils/http'
import Qs from 'Qs'
/**
 * 管理员菜单服务
 */
export default {
  all: (data) => http.get('/admin/menu/all', {params:data}), // 所有菜单列表
  getCurrent: () => http.get('/admin/menu/getCurrent'), // 获取当前用户菜单
  get: (data) => http.get('/admin/menu/get', {params:data}), // 根据id获取信息
  save: (data) => http.post('/admin/menu/save', Qs.stringify(data)), // 添加或修改保存
  delete: (data) => http.post('/admin/menu/delete', Qs.stringify(data)), // 根据id删除
  treeSelect: () => http.get('/admin/menu/treeSelect') // 树选择
}



// WEBPACK FOOTER //
// ./src/services/admin/AdminMenuService.js